import { Modal } from '@/components/atoms'
import { UploadFile } from '@/components/molecules'
import { uploadFileDescriptionForCSV } from '@/utils/commonTemplate'
import { Constants } from '@/utils/constants/commonConstants'
import { MODAL_TYPE } from '@/utils/constants/globalStyle'
import { useState, useRef } from 'react'
import { useAppDispatch } from '@/store'
import { setStoreListUrl } from '@/store/slices/salesTargetSlice'

export const UploadResult = Object.freeze({
  NONE: 'none',
  SUCCESS: 'success',
  ERROR: 'error',
})

const FileUploadWithModal = ({
  uploadFor = null,
  openUpload,
  setOpenUpload,
  formData,
  setFormData,
  title = 'Upload Targets',
  showTertiaryButton = false,
  fileType,
  isCsvValidationRequired = false,
  customRules = null,
  onClear,
  onCloseModal,
  ...props
}) => {

  let [uploadError, setUploadError] = useState(false)

  const [secondaryBtnText, setSecondaryBtnText] = useState(Constants.Cancel)
  const [uploading, setUploading] = useState(false)
  const dispatch = useAppDispatch()

  const fileUploadResultRef = useRef(UploadResult.NONE);

  const isCloseModal = () => {
    setOpenUpload(false)
    handleDelete()
    setSecondaryBtnText(Constants.Cancel)
    if (onClear) onClear();
    if (onCloseModal) onCloseModal(fileUploadResultRef.current)
  }

  const handleDelete = () => {
    if (formData?.targetMediaFile?.length > 0) return

    if (setFormData) {
      setFormData(prev => ({ ...prev, ...{ targetMediaFile: [] } }))
    }
  }


  const isFileError = secondaryBtnText !== Constants.Cancel

  return (
    <Modal
      isDark={true}
      onCloseModal={() => {
        handleDelete()
        isCloseModal()
        setUploadError(false)
      }}
      onClickSecondaryButton={() => {
        handleDelete()
        isCloseModal()
        setUploadError(false)
      }}
      onClickPrimaryButton={() => {
        if (!formData?.targetMediaFile || formData?.targetMediaFile?.length <= 0) {
          setUploadError(true)
          return
        }
        isCloseModal()
      }}
      showModal={openUpload}
      className="upload-target-modal"
      title={title}
      primaryButtonText={'Done'}
      primaryButtonDisabled={isFileError || !formData?.targetMediaFile || formData?.targetMediaFile?.length <= 0}
      type={MODAL_TYPE.SMALL}
      showSecondaryButton={true}
      secondaryButtonText={secondaryBtnText}
      data-testId="upload-target-modal"
      showTertiaryButton={isFileError && showTertiaryButton}
      onClickTertiaryButton={isCloseModal}
      tertiaryButtonText="Cancel"
      content={
        <UploadFile
          uploadFor={uploadFor}
          acceptedExtensions={Constants.CSV}
          description={uploadFileDescriptionForCSV()}
          label={Constants.UploadStoresFile}
          variant={Constants.Edit}
          feedbackType={uploadError ? Constants.Error : Constants.Info}
          required={true}
          files={formData?.targetMediaFile?.length > 0 ? [formData?.targetMediaFile] : []}
          getFileUrl={url => setFormData(prev => ({ ...prev, ...{ storeList: url } }))}
          onUpload={file => {
            setFormData(prev => ({ ...prev, ...{ targetMediaFile: [file?.name] } }))
            fileUploadResultRef.current = UploadResult.SUCCESS
            setUploadError(false)
          }}
          onUploadDelete={() => {
            setFormData(prev => ({ ...prev, ...{ targetMediaFile: [], storeList: '' } }))
            dispatch(setStoreListUrl(''))
          }}
          helperText={uploadError ? 'Wrong file type, please use CSV file' : ''}
          onUploadError={error => {
            if (error) {
              fileUploadResultRef.current = UploadResult.ERROR
              setUploadError(true)
            }
          }}
          type={Constants.Single}
          showDownloadTemplate={false}
          showHandleViewTable={false}
          className={formData?.targetMediaFile?.length > 0 && isFileError ? 'disabled' : ''}
          containerClassName={formData?.targetMediaFile?.length > 0 ? 'disabled' : ''}
          dataTestId="upload-file"
          setSecondaryBtnText={setSecondaryBtnText}
          uploading={uploading}
          setUploading={setUploading}
          fileType={fileType}
          isCsvValidationRequired={isCsvValidationRequired}
          customRules={customRules}
          {...props}
        />
      }
    />
  )
}

export default FileUploadWithModal
